// extracted by mini-css-extract-plugin
module.exports = {"bgimg":"viewpatient_bgimg__3ZFkE"};